// extracted by mini-css-extract-plugin
module.exports = {"title":"index_title__DJJHs","subtitle":"index_subtitle__NhoVR","content":"index_content__NJ8XP","component":"index_component__rJLeY"};